import { CSSProperties } from 'react';
import { handleTrack } from '../../../utils/tracker';

const commonStyles =
  'rounded-full flex items-center justify-center w-12 h-12 z-10 cursor-pointer bg-grey-140 text-grey-700 text-s-24 focus:outline-none';

const VARIANT_CLASSES_NEXT = {
  center: 'absolute left-[94%] bottom-[45%] z-10',
  extremeCenter:
    'absolute right-[-7%] bottom-[45%] z-10 sm:right-[35%] sm:bottom-[-48px]',
  default: 'left-16 relative mt-8',
  left: 'left-16 relative mt-8',
  topRight: 'absolute right-0 top-[-10%] z-10',
};

export const VARIANT_CLASSES_PREV = {
  center: 'absolute left-[94%] bottom-[45%] z-10',
  extremeCenter:
    'absolute left-[-7%] bottom-[45%] z-10 sm:left-[35%] sm:bottom-[-48px]',
  default: 'bottom-0 absolute',
  left: 'bottom-0 absolute',
  topRight: 'absolute right-[10%] sm:right-[20%] top-[-10%] z-10',
};

interface IPartnerNextArrow {
  className?: string;
  onClick?: () => void;
  style?: CSSProperties;
  variant?: keyof typeof VARIANT_CLASSES_NEXT;
  customArrowClasses?: string;
}
interface IPartnerPrevArrow {
  className?: string;
  onClick?: () => void;
  style?: CSSProperties;
  variant?: keyof typeof VARIANT_CLASSES_NEXT;
  customArrowClasses?: string;
}
export const PartnerNextArrow: React.FC<IPartnerNextArrow> = (
  props
): JSX.Element => {
  const {
    className,
    onClick,
    style,
    variant = 'default',
    customArrowClasses,
  } = props;

  const variantClasses = VARIANT_CLASSES_NEXT[variant];

  return (
    <div
      onClick={() => {
        handleTrack({
          label: 'slider-right-arrow',
        });
      }}
      className={
        customArrowClasses
          ? `${customArrowClasses}`
          : `${className} ${variantClasses}`
      }
      style={{ ...style }}
    >
      <button className={`${commonStyles}`} onClick={onClick}>
        →
      </button>
    </div>
  );
};

export const PartnerPrevArrow: React.FC<IPartnerPrevArrow> = (
  props
): JSX.Element => {
  const {
    className,
    onClick,
    style,
    variant = 'default',
    customArrowClasses,
  } = props;
  const variantClasses = VARIANT_CLASSES_PREV[variant];
  return (
    <div
      onClick={() => {
        handleTrack({
          label: 'slider-left-arrow',
        });
      }}
      className={
        customArrowClasses
          ? `${customArrowClasses}`
          : `${className} ${variantClasses}`
      }
      style={{ ...style }}
    >
      <button className={`${commonStyles}`} onClick={onClick}>
        ←
      </button>
    </div>
  );
};
